<template>
  <div>
    <MapBasic :loading-data="loading" :markers="filterLocations" :disable-back-navigation="filterOpen"/>
  </div>
</template>

<script>
import MapBasic from "@/components/MapBasic/MapBasic";

export default {
  name: "CircleMap",
  components: {MapBasic},
  props: {
    circleIds: {
      type: Array,
      required: true,
    },
    filterOpen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      locations: [],
      loading: false,
    };
  },
  created() {
    if (this.organizationId) {
      this.getLocations();
    }
  },
  computed: {
    organizationId() {
      return this.$store.getters.getOrganizationId;
    },
    filterLocations() {
      return [...this.locations.filter((location) => location.CirclesID.some(id => this.circleIds.includes(id)) && location.Location && location.Location.Position)
          .map(location => ({
            ...location.Location,
            lat: location.Location.Position.Latitude,
            lng: location.Location.Position.Longitude
          })), ...this.locations.filter((location) => location.CirclesID.some(id => this.circleIds.includes(id)) && location.Alert && location.Alert.Location)
          .map(location => ({
            ...location.Alert,
            lat: location.Alert.Location.Latitude,
            lng: location.Alert.Location.Longitude,
            OwnerID: location.UserID
          }))];
    }
  },
  watch: {
    organizationId() {
      this.getLocations();
    }
  },
  methods: {
    getLocations() {
      const url = this.$store.getters.organizationLocations;
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.axios.get(url).then(({data}) => {
        this.locations = data.Result.map((location) => ({
          ...location,
          lat: location.Latitude,
          lng: location.Longitude
        }));
      }).finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 600);
      });
    }
  }
};
</script>

<style scoped>

</style>